import { classFilter } from '@shieldpay/theme-provider-ui/utilities';

import type { BoxProps } from '../box/box';
import { Box } from '../box/box';
import { filterDisplayProps } from '../box/utils';

import * as styles from './card.css';

export interface CardProps
  extends Pick<
    BoxProps,
    | 'padding'
    | 'size'
    | 'spacing'
    | 'background'
    | 'stack'
    | 'className'
    | 'children'
    | 'Component'
    | 'method'
    | 'alignContent'
    | 'role'
    | 'htmlFor'
    | 'style'
    | 'expand'
    | 'constrain'
    | 'onClick'
    | 'onSubmit'
    | 'ref'
  > {
  boxVariant?: BoxProps['variant'];
  variant?: keyof typeof styles.variant;
  'data-testid'?: string;
}

const TEST_IDS = {
  CARD: 'card-component',
};

const borderPalette: Record<
  NonNullable<CardProps['variant']>,
  BoxProps['border']
> = {
  primary: 'neutral200',
  lightShadow: 'neutral350',
  darkShadow: undefined,
};

export const Card = ({
  variant = 'primary',
  boxVariant = 'flex',
  padding = 'basePos4',
  'data-testid': testId = TEST_IDS.CARD,
  background = 'neutral000',
  className,
  children,
  spacing,
  alignContent,
  stack,
  ref,
  ...props
}: CardProps) => (
  <Box
    className={classFilter([styles.variant[variant], className])}
    border={borderPalette[variant]}
    background={background}
    data-testid={testId}
    padding={padding}
    ref={ref}
    rounded
    spacing={spacing}
    {...filterDisplayProps({ variant: boxVariant, alignContent, stack })}
    {...props}
  >
    {children}
  </Box>
);
